import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { DayPilot } from "@daypilot/daypilot-lite-angular";
import { HttpClient } from "@angular/common/http";

export interface AppointmentEvent {
  id: string;
  start: DayPilot.Date;
  end: DayPilot.Date;
  text: string;
  backColor?: string;
  appointments: string[]; // store multiple patients in one block
}

@Injectable()
export class DataService {

  static colors = {
    green: "#6aa84f",
    yellow: "#f1c232",
    red: "#cc4125",
    gray: "#808080",
    blue: "#2e78d6",
  };

  events: AppointmentEvent[] = [
    {
      id: DayPilot.guid(),
      text: "10:00 Slot",
      start: DayPilot.Date.today().firstDayOfWeek().addHours(10),
      end: DayPilot.Date.today().firstDayOfWeek().addHours(11),
      appointments: ["Patient 1", "Patient 2"],
      backColor: DataService.colors.green
    },
    {
      id: DayPilot.guid(),
      text: "12:00 Slot",
      start: DayPilot.Date.today().firstDayOfWeek().addDays(1).addHours(12),
      end: DayPilot.Date.today().firstDayOfWeek().addDays(1).addHours(13),
      appointments: ["Patient 3"],
      backColor: DataService.colors.yellow
    },
    {
      id: DayPilot.guid(),
      text: "13:00 Slot",
      start: DayPilot.Date.today().firstDayOfWeek().addDays(2).addHours(13),
      end: DayPilot.Date.today().firstDayOfWeek().addDays(2).addHours(14),
      appointments: ["Patient 4", "Patient 5", "Patient 6"],
      backColor: DataService.colors.red
    }
  ];

  constructor(private http: HttpClient) { }

  // Get events between two dates
  getEvents(from: DayPilot.Date, to: DayPilot.Date): Observable<AppointmentEvent[]> {
    // Simulate HTTP request
    return new Observable(observer => {
      const filteredEvents = this.events.filter(e =>
        e.start.valueOf() >= from.valueOf() && e.start.valueOf() <= to.valueOf()
      );
      setTimeout(() => {
        observer.next(filteredEvents);
      }, 200);
    });

    // Example for real API:
    // return this.http.get<AppointmentEvent[]>(`/api/events?from=${from}&to=${to}`);
  }

  // Get list of colors
  getColors(): { name: string, id: string }[] {
    return [
      { name: "Green", id: DataService.colors.green },
      { name: "Yellow", id: DataService.colors.yellow },
      { name: "Red", id: DataService.colors.red },
      { name: "Gray", id: DataService.colors.gray },
      { name: "Blue", id: DataService.colors.blue }
    ];
  }

  // Add a new appointment to a block
  addAppointment(slotId: string, patientName: string) {
    const event = this.events.find(e => e.id === slotId);
    if (event) {
      event.appointments.push(patientName);
    }
  }
}
